<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Routes</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item-divider color="tertiary">
        Shuttles With No Routes Assigned
    </ion-item-divider>

    <ion-list data-test="idleShuttles">
        @for (shuttle of idleShuttles; track $index) {
  <ion-item [disabled]="vb.disabled">
            <span class="line1">{{shuttle.shuttleName}}</span><br />
        </ion-item>
}
    </ion-list>

    <ion-item-divider color="tertiary">
        Shuttles With Routes Assigned
    </ion-item-divider>

    <ion-list data-test="assignedShuttles">
        @for (shuttle of assignedShuttles; track $index) {
  <ion-item [disabled]=vb.disabled detail="true"
                    (click)="onOpenRouteClick(shuttle)" href="javascript:;">
            <span class="line1">{{shuttle.shuttleName}}</span><br />
        </ion-item>
}
    </ion-list>

    <ion-item-divider color="tertiary">
        Shuttles Out Traveling
    </ion-item-divider>

    <ion-list data-test="travellingShuttles">
        @for (shuttle of travelingShuttles; track $index) {
  <ion-item [disabled]=vb.disabled  detail="true" 
                (click)="onOpenRouteClick(shuttle)" href="javascript:;">
            <span class="line1">{{shuttle.shuttleName}}</span><br />
        </ion-item>
}
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]="vb.disabled || idleShuttles.length == 0" title="Next" data-test="addRoute"
                (click)="onAddClick()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
